import { useEffect, useState } from 'react'
import "./style.css"
import { Alert, ButtonGroup, Container, Dropdown, DropdownButton, Nav, Navbar, Button, Card, Row, Col, Badge } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import FileUploadModal from './UploadFiles';
import AddTextBlocks from './AddTextBlock';
import AddFAQ from './AddFAQ';
import AddLinks from './AddLinks';
import ListTextBlocks from './List/ListTextBlocks';
import ListWebLinks from './List/ListWebLinks';
import ListFiles from './List/ListFiles';
import ListFAQs from './List/ListFAQs';
import { useAgentContext } from '../../context/agent';
import { useOrgContext } from '../../context/org';
import { 
    FaDatabase, 
    FaPlus, 
    FaFileAlt, 
    FaLink, 
    FaUpload, 
    FaQuestionCircle,
    FaExclamationTriangle,
    FaBrain
} from 'react-icons/fa';
import { useQuery } from 'react-query';
import { getFaqs, getFiles, getTextBlocks, getWebLinks } from '../../api/agent';
import ManageFAQ from './ManageFAQ';
import ManageTextBlock from './ManageTextBlock';

const Knowledgebase = () => {
    const [addFAQ, setAddFAQ] = useState(false)
    const [addText, setAddText] = useState(false)
    const [addLinks, setAddLinks] = useState(false)
    const [addFiles, setAddFiles] = useState(false)
	const [dataCount, setDataCount] = useState(0)

    const {orgId, agentId} = useParams();
	
    const {data: textBlocks} = useQuery({
        queryKey: ['TextBlocks', agentId],
        queryFn: () => getTextBlocks({orgId: orgId!, agentId: agentId!}),
        enabled: !!orgId && !!agentId,
    });

	const {data: webLinks} = useQuery({
		queryKey: ['WebLinks', agentId],
		queryFn: () => getWebLinks({orgId: orgId!, agentId: agentId!}),
		enabled: !!orgId && !!agentId,
	});

	const {data: files} = useQuery({
		queryKey: ['Files', agentId],
		queryFn: () => getFiles({orgId: orgId!, agentId: agentId!}),
		enabled: !!orgId && !!agentId,
	});

	const {data: faqs} = useQuery({
		queryKey: ['Faqs', agentId],
		queryFn: () => getFaqs({orgId: orgId!, agentId: agentId!}),
		enabled: !!orgId && !!agentId,
	});

	const {getOrgById, membership} = useOrgContext();
    const allowed = ["owner", "admin", "editor"]
    let faqPermission = false;
    let dataPermission = false;
    let permission = !allowed.includes(membership?.role || "");
    const org = getOrgById(orgId || "");
    if(org) {
        dataPermission = org.dataSourcesLeft <= 0;
        faqPermission = org.faqsLeft <= 0;
    }

	// Count total data items
	useEffect(() => {
		let count = 0;
		if (textBlocks) count += textBlocks.length;
		if (webLinks) count += webLinks.length;
		if (files) count += files.length;
		if (faqs) count += faqs.length;
		setDataCount(count);
	}, [textBlocks, webLinks, files, faqs]);

    return (
        <div style={{ backgroundColor: '#1a1a1a', color: '#ffffff', minHeight: '100vh' }}>
			{addFAQ && <ManageFAQ show={addFAQ} setShow={setAddFAQ}/>}
            {addText && <ManageTextBlock show={addText} setShow={setAddText}/>}
            {addFiles && <FileUploadModal show={addFiles} setShow={setAddFiles}/>}
            {addLinks && <AddLinks show={addLinks} setShow={setAddLinks}/>}
            
            {/* Header */}
            <div style={{ backgroundColor: '#2d2d2d', borderBottom: '1px solid #444' }} className="sticky-top">
                <Container fluid className="py-3">
                    <Row className="align-items-center">
                        <Col>
                            <div className="d-flex align-items-center">
                                <div className="bg-primary rounded p-2 me-3">
                                    <FaDatabase className="text-white" />
                                </div>
                                <div>
                                    <h4 className="mb-0 text-light">Knowledge Base</h4>
                                    <small style={{ color: '#999' }}>
                                        Manage your agent's training data and information sources
                                    </small>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            <div className="p-4">

                {/* Subscription Alert */}
                {org && org.dataSourcesLeft <= 0 && (
                    <div 
                        className="p-3 mb-4 rounded-3 d-flex align-items-center"
                        style={{ backgroundColor: "#2d2a1a", border: "1px solid #ffc107" }}
                    >
                        <FaExclamationTriangle className="text-warning me-3" size={20} />
                        <div className="flex-grow-1">
                            <p className="text-warning mb-0 fw-semibold">
                                Data source limit reached
                            </p>
                            <small style={{ color: "#ccc" }}>
                                <Link to={`/dashboard/orgs/${orgId}/plans`} className="text-warning">
                                    Upgrade your subscription
                                </Link> to add more data sources.
                            </small>
                        </div>
                    </div>
                )}

                {/* Add Data Actions */}
                <div 
                    className="p-4 rounded-3 mb-4"
                    style={{ backgroundColor: "#2d2d2d", border: "1px solid #444" }}
                >
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <h4 className="text-light mb-0" style={{ fontSize: "20px", fontWeight: "600" }}>
                            Add Training Data
                        </h4>
                        {dataCount > 0 && (
                            <Badge bg="secondary" className="px-3 py-2">
                                {dataCount} items
                            </Badge>
                        )}
                    </div>

                    <Row className="g-3">
                        <Col md={3} sm={6}>
                            <Button
                                variant="outline-light"
                                className="w-100 h-100 d-flex flex-column align-items-center p-4 custom-action-btn"
                                disabled={permission || dataPermission}
                                onClick={() => setAddText(true)}
                                style={{
                                    backgroundColor: permission || dataPermission ? '#2a2a2a' : '#333',
                                    borderColor: '#555',
                                    minHeight: '120px',
                                    transition: 'all 0.2s ease',
                                    color: '#fff'
                                }}
                                onMouseEnter={(e) => {
                                    if (!permission && !dataPermission) {
                                        e.currentTarget.style.backgroundColor = '#444';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!permission && !dataPermission) {
                                        e.currentTarget.style.backgroundColor = '#333';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                            >
                                <FaFileAlt size={24} className="mb-2 text-primary" />
                                <span className="fw-semibold" style={{ color: '#fff' }}>Text Blocks</span>
                                <small className="mt-1" style={{ color: "#ccc" }}>Add custom text content</small>
                            </Button>
                        </Col>
                        <Col md={3} sm={6}>
                            <Button
                                variant="outline-light"
                                className="w-100 h-100 d-flex flex-column align-items-center p-4"
                                disabled={permission || dataPermission}
                                onClick={() => setAddFiles(true)}
                                style={{
                                    backgroundColor: permission || dataPermission ? '#2a2a2a' : '#333',
                                    borderColor: '#555',
                                    minHeight: '120px',
                                    transition: 'all 0.2s ease',
                                    color: '#fff'
                                }}
                                onMouseEnter={(e) => {
                                    if (!permission && !dataPermission) {
                                        e.currentTarget.style.backgroundColor = '#444';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!permission && !dataPermission) {
                                        e.currentTarget.style.backgroundColor = '#333';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                            >
                                <FaUpload size={24} className="mb-2 text-success" />
                                <span className="fw-semibold" style={{ color: '#fff' }}>Upload Files</span>
                                <small className="mt-1" style={{ color: "#ccc" }}>PDF, DOC, TXT files</small>
                            </Button>
                        </Col>
                        <Col md={3} sm={6}>
                            <Button
                                variant="outline-light"
                                className="w-100 h-100 d-flex flex-column align-items-center p-4"
                                disabled={permission || dataPermission}
                                onClick={() => setAddLinks(true)}
                                style={{
                                    backgroundColor: permission || dataPermission ? '#2a2a2a' : '#333',
                                    borderColor: '#555',
                                    minHeight: '120px',
                                    transition: 'all 0.2s ease',
                                    color: '#fff'
                                }}
                                onMouseEnter={(e) => {
                                    if (!permission && !dataPermission) {
                                        e.currentTarget.style.backgroundColor = '#444';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!permission && !dataPermission) {
                                        e.currentTarget.style.backgroundColor = '#333';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                            >
                                <FaLink size={24} className="mb-2 text-info" />
                                <span className="fw-semibold" style={{ color: '#fff' }}>Web Links</span>
                                <small className="mt-1" style={{ color: "#ccc" }}>Import from websites</small>
                            </Button>
                        </Col>
                        <Col md={3} sm={6}>
                            <Button
                                variant="outline-light"
                                className="w-100 h-100 d-flex flex-column align-items-center p-4"
                                disabled={permission || faqPermission}
                                onClick={() => setAddFAQ(true)}
                                style={{
                                    backgroundColor: permission || faqPermission ? '#2a2a2a' : '#333',
                                    borderColor: '#555',
                                    minHeight: '120px',
                                    transition: 'all 0.2s ease',
                                    color: '#fff'
                                }}
                                onMouseEnter={(e) => {
                                    if (!permission && !faqPermission) {
                                        e.currentTarget.style.backgroundColor = '#444';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!permission && !faqPermission) {
                                        e.currentTarget.style.backgroundColor = '#333';
                                        e.currentTarget.style.color = '#fff';
                                    }
                                }}
                            >
                                <FaQuestionCircle size={24} className="mb-2 text-warning" />
                                <span className="fw-semibold" style={{ color: '#fff' }}>FAQ</span>
                                <small className="mt-1" style={{ color: "#ccc" }}>Question & answer pairs</small>
                            </Button>
                        </Col>
                    </Row>
                </div>

                {/* Empty State */}
                {dataCount === 0 && (
                    <div 
                        className="text-center py-5"
                        style={{ backgroundColor: "#2d2d2d", borderRadius: "12px", border: "1px solid #444" }}
                    >
                        <FaBrain size={48} className="mb-3" style={{ color: "#888" }} />
                        <h4 className="text-light mb-2">No training data added yet</h4>
                        <p className="mb-0" style={{ color: "#ccc" }}>
                            Start by adding some content to train your agent
                        </p>
                    </div>
                )}

                {/* Data Lists */}
                {textBlocks && orgId && <ListTextBlocks textBlocks={textBlocks} orgId={orgId} permission={permission} />}
                {webLinks && orgId && <ListWebLinks webLinks={webLinks} orgId={orgId} permission={permission} />}
                {files && orgId && <ListFiles files={files} orgId={orgId} permission={permission} />}
                {faqs && orgId && <ListFAQs faqs={faqs} orgId={orgId} permission={permission} />}
            </div>
        </div>
    )
}
export default Knowledgebase